import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    FeedbackSlider();
});

function FeedbackSlider() {
    var swipers = document.querySelectorAll('.swiper.slider-feedback');

    swipers.forEach(function(swiper) {

        var swiperSlider = new Swiper(swiper, {
            modules: [Navigation, Pagination],
            loop: false,
            speed: 500,
            slidesPerView: 1,
            spaceBetween: 32,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: '.customnext',
                prevEl: '.customprev',
            },
            pagination: {
                el: ".swiper-pagination",
            }
        });

    });
}